import { VerticalContainer } from '@american-autonomy/ag-ui';

import Banner from 'components/Banner';
import Modal from 'components/Modal';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import ApplicationDetailsSection from './components/ApplicationDetailsSection';
import ApplicatorSection from './components/ApplicatorSection';
import ComingSoonNotice from './components/ComingSoonNotice';
import ComplianceFooter from './components/ComplianceFooter';
import SignatureSection from './components/SignatureSection';
import TankMixSection from './components/TankMixSection';
import TankVolumeSection from './components/TankVolumeSection';
import WeatherSection from './components/WeatherSection';
import { TEST_ID, UNLICENSED_WARNING_TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const StateComplianceModal: FunctionComponent<Props> = ({
    application,
    className,
    isOpen,
    mixRecipe,
    onClose,
    tankState,
    testId = TEST_ID,
    weather
}) => {
    const translations = useTranslation();
    const {
        handleDownloadPdf,
        hasUnlicensedProduct,
        isComingSoonState,
        stateTitle,
        tankVolumeSummary
    } = useData({
        application,
        mixRecipe,
        tankState,
        weather
    });

    const rootClassName = className
        ? `${styles.stateComplianceModal} ${className}`
        : styles.stateComplianceModal;

    const footer = (
        <ComplianceFooter
            isPdfDisabled={hasUnlicensedProduct}
            onClose={onClose}
            onDownloadPdf={handleDownloadPdf}
        />
    );

    return (
        <Modal
            className={rootClassName}
            footer={footer}
            isOpen={isOpen}
            onClose={onClose}
            testId={testId}
            title={stateTitle}>
            {isComingSoonState ? (
                <ComingSoonNotice />
            ) : (
                <VerticalContainer className={styles.modalBodyContainer}>
                    {hasUnlicensedProduct && (
                        <Banner
                            metadata={translations.UNLICENSED_REMEDIATION}
                            testId={UNLICENSED_WARNING_TEST_ID}
                            text={translations.UNLICENSED_WARNING_BODY}
                            variant='warn'
                        />
                    )}

                    <ApplicationDetailsSection application={application} />

                    <ApplicatorSection application={application} />

                    <TankMixSection mixRecipe={mixRecipe} totalAcres={application.totalAcres} />

                    <WeatherSection weather={weather} />

                    <TankVolumeSection tankVolumeSummary={tankVolumeSummary} />

                    <SignatureSection />
                </VerticalContainer>
            )}
        </Modal>
    );
};

export default StateComplianceModal;
